<template>
  <div class="devise-page">
    <iframe title="可视化编辑容器" id="iframe" class="iframe-box" :src="iframeUrl" frameborder="0" ref="iframe"></iframe>
    <div class="content">
      <right-config :index="index"></right-config>
    </div>
  </div>
</template>

<script>
  import rightConfig from './right-config/right-config.vue'
  export default {
    name: 'devise-page',
    components: {
      rightConfig,
    },
    data() {
      return {
        iframeUrl:  process.env.VUE_APP_MODE == 'production' ? 'https://h5.jiangxi.cq-1mi.com/#/pages/index/index?type=iframeWindow' : 'https://h5.assioc-cms.jsdotech.com/#/pages/index/index?type=iframeWindow',
        index: null,
        query: {},
        search: {},
        diyDom: {},
        diyData: {},
        apiData: {},
      }
    },
    methods: {
      //接收iframe值
      handleMessage(event) {
        if (event.data.index) {
          this.index = event.data.index
        }
      },
      // 重新加载iframe
      reloadIframe() {
        document.getElementById('iframe').src = this.iframeUrl
      },
    },
    mounted() {
      this.$bus.$on('on-change', this.reloadIframe)
      //监听子页面给当前页面传值
      window.addEventListener('message', this.handleMessage, false)
      console.log(process.env.VUE_APP_MODE);
    },
  }
</script>

<style scoped lang="less">
  .devise-page {
    display: flex;
    .iframe-box {
      min-width: 375px;
      height: 700px;
      border-radius: 4px;
      box-shadow: 0 0 7px #cccccc;
    }
    .content {
      flex: 1;
      height: 700px;
      overflow-y: auto;
    }
  }
</style>
